import { HLHLContactRole } from "../../../../shared/types/api";

export const SAVE_HLHL_CONTACT_ROLE = "@SaveHLHLContactRole/SAVE_HLHL_CONTACT_ROLE";

export interface HLHLContactRoleShape {
  hlhl_contact_role: HLHLContactRole;
}
